module.exports = __webpack_public_path__ + "img/닌자.fcee90f6.png";